import api from './index'

const axios = require('axios')

export default {
    getAll: () => {
        const path = '/actives/all'

        return api.handling(axios.get(path))
    },

    getByID: (id) => {
        const path = `/actives/${id}`

        return api.handling(axios.get(path))
    },

    updateByID: (id, data) => {
        const path = `/actives/${id}`

        return api.handling(axios.put(path, data))
    },

    create: (data) => {
        const path = '/actives/create'

        return api.handling(axios.post(path, data))
    },

    deleteByID: (id) => {
        const path = `/actives/${id}`

        return api.handling(axios.post(path))
    },

    getActiveToMachine: (id) => {
        const path = `/actives/machines/${id}`

        return api.handling(axios.get(path))
    },

    getSerialNumberListByID: (id) => {
        const path = `/actives/serial-number/all/${id}`

        return api.handling(axios.get(path))
    },

    createSerialNumberByID: (id, data) => {
        const path = `/actives/serial-number/create/${id}`

        return api.handling(axios.post(path, data))
    },

    importSerialNumberByID: (id, data) => {
        const path = `/actives/serial-number/import/${id}`

        return api.handling(axios.post(path, data))
    },

    deleteSerialNumberByID: (id, serialNumberId) => {
        const path = `/actives/serial-number/delete/${id}/${serialNumberId}`

        return api.handling(axios.post(path))
    },

    exportSerialNumberByID: (id) => {
        const path = `/actives/serial-number/export/${id}`

        return api.handling(axios.get(path))
    },

}
